import { render, staticRenderFns } from "./customerinfo.vue?vue&type=template&id=7f7c2c73&scoped=true&"
import script from "./customerinfo.vue?vue&type=script&lang=js&"
export * from "./customerinfo.vue?vue&type=script&lang=js&"
import style0 from "./customerinfo.vue?vue&type=style&index=0&id=7f7c2c73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7c2c73",
  null
  
)

export default component.exports